var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#662D91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0769 12.7697H10.9231C10.4133 12.7697 10 13.1829 10 13.6927V21.0773C10 21.5872 10.4133 22.0004 10.9231 22.0004H21.0769C21.5867 22.0004 22 21.5872 22 21.0773V13.6927C22 13.1829 21.5867 12.7697 21.0769 12.7697Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7692 12.7692V10.9231C18.7692 10.6783 18.6719 10.4435 18.4988 10.2704C18.3257 10.0973 18.0909 10 17.8461 10H14.1538C13.909 10 13.6742 10.0973 13.5011 10.2704C13.328 10.4435 13.2307 10.6783 13.2307 10.9231V12.7692",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1781 16.1538C17.1375 16.0392 17.075 15.9349 16.9955 15.8462C16.8265 15.6573 16.5809 15.5385 16.3075 15.5385H15.593C15.1379 15.5385 14.769 15.9074 14.769 16.3624C14.769 16.7496 15.0387 17.0846 15.4169 17.1674L16.5048 17.4053C16.9285 17.498 17.2306 17.8736 17.2306 18.3074C17.2306 18.8171 16.8173 19.2308 16.3075 19.2308H15.6921C15.2902 19.2308 14.9483 18.9739 14.8216 18.6154",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.5384V14.6154",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.1539V19.2308",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAum);
export default __webpack_public_path__ + "static/media/aum.0fb27caaf8d606f7191908f05d00939a.svg";
export { ForwardRef as ReactComponent };